import { SEARCH_BAR_MIN_HEIGHT } from '@/core/constants/layout';

export const searchBarStyles = {
	root: (fullWidth: boolean, fullHeight: boolean) => ({
		display: 'flex',
		position: 'relative',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxWidth: '663px',
		width: {
			xs: fullWidth ? '100%' : '70%',
			md: '100%'
		},
		height: fullHeight ? '56px' : `${SEARCH_BAR_MIN_HEIGHT}px`,
		bgcolor: 'background.paper',
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: '4px',
		padding: '4px 8px',
		boxSizing: 'border-box', // Prevent height issues

		'&:hover': {
			border: '1px solid #1212124D'
		},
		'&:focus-within': {
			border: '1px solid var(--mui-palette-primary-main)'
		},
		'& .MuiInputBase-input': {
			padding: 0
		}
	}),
	inputField: {
		ml: 1,
		flex: 1,
		lineHeight: 1.5,

		'& .MuiInputBase-input': {
			color: 'text.fadedPrimary'
		}
	},
	searchIcon: {
		width: '20px',
		height: '20px',
		color: 'text.secondary',
		mr: 1
	},
	clearIcon: {
		mr: 0.5
	},
	placeholder: {
		'::placeholder': {
			color: 'text.secondary',
			opacity: 1
		}
	}
};
